import { render, staticRenderFns } from "./Promocode.vue?vue&type=template&id=4cbb50bc&scoped=true&"
import script from "./Promocode.vue?vue&type=script&lang=js&"
export * from "./Promocode.vue?vue&type=script&lang=js&"
import style0 from "./Promocode.vue?vue&type=style&index=0&id=4cbb50bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb50bc",
  null
  
)

export default component.exports